/* eslint-disable */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {StyleSheet, css} from 'aphrodite';
import {Theme} from '../../config/theme';
import {mapStateToProps, mapDispatchToProps} from '../../utils';

import {logout, sendForgotPasswordRequest,sendResetPasswordRequest} from '../../actions/user';
import {updateAppState} from '../../actions/applicationState';

import DashboardHeader from '../../components/DashboardHeader';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';
import Body from '../../components/Body';
import Footer from '../../components/Footer';
import TextField from '../../components/TextField';

let styles;
const BACKGROUND_ASSET = require('./background.jpg');

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.user.email,
      forgotPassword: false,
      passwordReset: false,
      errorMessage: false,
      token: null,
    };

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);
    this.forgotPassword = this.forgotPasswordHandler.bind(this);
    this.resetPassword = this.resetPasswordHandler.bind(this);
    this.setValue = this.updateTextField.bind(this);
  }

  componentDidMount() {
    this.setState({
      token: this.findGetParameter('token'),
      member_id: this.findGetParameter('id'),
    });
  }

  updateTextField(key, value) {
    this.setState({
      [key]: value,
    });
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  loginModalOpenHandler() {
    this.props.dispatch(updateAppState({
      login_modal_open: true,
    }));
  }

  loginModalOpenHandler() {
    this.props.dispatch(updateAppState({
      login_modal_open: true,
    }));
  }

  forgotPasswordHandler(e) {
    e.preventDefault();

    this.props.dispatch(updateAppState({
      loading: true,
      loading_text: 'Sending...',
    })).then(() => {

      this.props.dispatch(sendForgotPasswordRequest({
        email: this.state.email,
      })).then((response) => {

        console.log('sendForgotPasswordRequest response', response);

        this.props.dispatch(updateAppState({
          loading: false,
        }));

        if (response.status === 200) {
          this.setState({
            forgotPassword: true,
          });
        } else {

          this.setState({
            forgotPassword: false,
            errorMessage: response.data.error,
          });
        }

      });

    });
  }

  resetPasswordHandler(e) {
    e.preventDefault();

    this.props.dispatch(updateAppState({
      loading: true,
      loading_text: 'Sending...',
    })).then(() => {

      this.props.dispatch(sendResetPasswordRequest({
        token: this.state.token,
        password: this.state.password,
        id: this.state.member_id,
      })).then((response) => {

        console.log('resetPasswordHandler response', response);

        this.props.dispatch(updateAppState({
          loading: false,
        }));

        if (response.status === 200) {
          this.setState({
            resetPassword: true,
          });
        } else {
          this.setState({
            resetPassword: false,
            errorMessage: response.data.error,
          });
        }

      });

    });
  }

  findGetParameter(parameterName) {
    let result = null,
      tmp = [];
    let items = location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
  }

  resetForm() {
    return (<form className={css(styles.form)}>
      <h1 className={css(styles.title)}>Reset your password</h1>
      <p className={css(styles.content)}>
        Enter your new password below.
      </p>
      { this.state.errorMessage ? (<div className={css(styles.error_box, styles.form_error)}>{this.state.errorMessage}</div>) : null }
      <TextField
        id="password"
        name="password"
        label="Password"
        type="password"
        value={this.state.password}
        handler={this.setValue}
      />
      <TextField
        id="confirm_password"
        name="confirm_password"
        label="Confirm Password"
        type="password"
        value={this.state.confirm_password}
        handler={this.setValue}
      />
      <div className={css(styles.submit_container)}>
        <button
          className={css(styles.submit)}
          onClick={this.resetPassword}>
          Submit
        </button>
      </div>
    </form>);
  }


  forgotForm() {
    return (<form className={css(styles.form)}>
      <h1 className={css(styles.title)}>Forgot your password?</h1>
      <p className={css(styles.content)}>
        Enter your email below.
      </p>
      { this.state.errorMessage ? (<div className={css(styles.error_box, styles.form_error)}>{this.state.errorMessage}</div>) : null }
      <TextField
        id="email"
        name="email"
        label="Email"
        value={this.state.email}
        handler={this.setValue}
        email
      />
      <div className={css(styles.submit_container)}>
        <button
          className={css(styles.submit, styles.login)}
          onClick={this.forgotPassword}>
          Submit
        </button>
      </div>
    </form>);
  }

  render() {
    return (
      <Body hasFooter>
      {
        this.props.user.isAuthenticated ? (
          <DashboardHeader
            logoutHandler={this.logoutHandler}
            redirectHandler={this.redirectHandler}
            {...this.props} />
        ) : (
          <UnauthenticatedHeader openLoginHandler={this.openLoginHandler}/>
        )
      }
      <div className={css(styles.container)}>
        {
          this.state.resetPassword || this.state.forgotPassword ?

            this.state.resetPassword ? (<div className={css(styles.contact_box)}>
              <h1 className={css(styles.title)}>Your password has been reset!</h1>
              <p className={css(styles.content)}>
                {'You can now login with your new password.'}
              </p>
              <button
                className={css(styles.submit, styles.login)}
                onClick={this.openLoginHandler}>Login now</button>
            </div>) : (<div className={css(styles.contact_box)}>
              <h1 className={css(styles.title)}>We've sent you an email.</h1>
              <p className={css(styles.content)}>
                {'Click the link that we\'ve sent you in order to reset your password'}
              </p>
            </div>)
          :
          <div className={css(styles.contact_box)}>
            {
              this.state.token && this.state.member_id ? this.resetForm() : this.forgotForm()
            }
          </div>
        }
      </div>
      <Footer {...this.props} />
      </Body>
    );
  }
}

Contact.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 'calc(100vh - 240px)',
    paddingTop: 127,
    paddingBottom: 91,
    backgroundImage: `url('${BACKGROUND_ASSET}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    [Theme.mobile_query]: {
      marginTop: 80,
      paddingTop: 209,
      paddingBottom: 0,
      backgroundPosition: 'top center',
      backgroundSize: 'auto 209px',
      backgroundImage: 'url(/images/contact_bg_mob.jpg)',
    },
  },
  error_box: {
    color: Theme.red,
    paddingBottom: 40,
  },
  form_error: {
    width: '100%',
  },
  contact_box: {
    width: 760,
    margin: '0 auto',
    padding: 60,
    backgroundColor: Theme.white,

    [Theme.mobile_query]: {
      width: '100%',
      padding: '60px 20px',
    },
  },
  title: {
    marginBottom: 30,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'center',
  },
  content: {
    width: 631,
    margin: '0 auto 50px',
    fontFamily: Theme.font_family_primary,
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.4,
    textAlign: 'center',
    color: '#000e1f',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 -5px',
  },
  submit_container: {
    width: '100%',
    padding: '0 5px',
    textAlign: 'right',
    marginTop: 10,
  },
  submit: {
    width: 206,
    height: 50,
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: Theme.white,
    borderRadius: 5,
    border: 0,
    backgroundColor: Theme.primary,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    ':hover': {
      backgroundColor: '#61c3df',
    },

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  login: {
    textAlign: 'center',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./src/views/Forgot/index.js